import { Droplets, Shield, Leaf, Sparkles } from "lucide-react";

export const KeyBenefits = () => {
  const benefits = [
    {
      icon: Droplets,
      title: "Enhanced Hydration",
      description: "Helps your tree absorb water more efficiently than plain tap water alone."
    },
    {
      icon: Sparkles,
      title: "Helps Scent Pop",
      description: "Helps draw out natural oils in the needles so your home smells like Christmas morning."
    },
    {
      icon: Shield,
      title: "Bacterial Protection",
      description: "Food-safe preservatives help prevent microbial buildup that can block water uptake."
    },
    {
      icon: Leaf,
      title: "Needle Retention",
      description: "Proper nutrition helps needles stay green and firmly attached longer."
    }
  ];

  return (
    <section className="py-10 md:py-14 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center space-y-4 group cursor-default">
              <div className="w-16 h-16 mx-auto rounded-full bg-primary/10 flex items-center justify-center transition-all duration-300 group-hover:bg-primary/20 group-hover:scale-110">
                <benefit.icon className="w-8 h-8 text-primary transition-transform duration-300 group-hover:scale-110" />
              </div>
              <h3 className="font-cormorant text-xl font-bold text-foreground transition-colors duration-300 group-hover:text-primary">
                {benefit.title}
              </h3>
              <p className="text-sm text-muted-foreground font-inter leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
